import { lazy } from 'react';
import { RouteType } from '@/Routes';
import { Route } from 'react-router';

const Login = lazy(() => import('@/pages/control_panel/login'));
const CompanyPartnerSignup = lazy(
  () => import('@/pages/control_panel/company_partner_signup')
);
const Index = lazy(() => import('@/pages/control_panel'));
const AgeApproval = lazy(() => import('@/pages/control_panel/age_approval'));
const KeijiApproval = lazy(
  () => import('@/pages/control_panel/keiji_approval')
);
const AnalysisUser = lazy(() => import('@/pages/control_panel/analysis/user'));
const ProfileApproval = lazy(
  () => import('@/pages/control_panel/profile_approval')
);
const ProfileImageApproval = lazy(
  () => import('@/pages/control_panel/profile_image_approval')
);
const EditConstants = lazy(
  () => import('@/pages/control_panel/edit_constants')
);
const AdminAgentLogo = lazy(() => import('@/pages/control_panel/agents/logo'));
const ChangeUserType = lazy(
  () => import('@/pages/control_panel/change_user_type')
);
const Transfer = lazy(() => import('@/pages/control_panel/transfer'));

const indexRoutes: RouteType[] = [
  { path: 'age_approval', component: AgeApproval },
  { path: 'keiji_approval', component: KeijiApproval },
  { path: 'analysis/user', component: AnalysisUser },
  {
    path: 'profile_image_approval/:type(main|sub)',
    component: ProfileImageApproval,
  },
  {
    path: 'profile_approval',
    component: ProfileApproval,
  },
  {
    path: 'company_partner_signup',
    component: CompanyPartnerSignup,
    title: '企業パートナー登録',
  },
  {
    path: 'agents/logo',
    component: AdminAgentLogo,
    title: '企業パートナーロゴ編集',
  },
  { path: 'edit_constants', component: EditConstants, title: '固定値編集' },
  {
    path: 'change_user_type',
    component: ChangeUserType,
    title: 'ユーザータイプ変更',
  },
  {
    path: 'transfer',
    component: Transfer,
    title: '振り込み',
  },
];

const ServerControlPanel: RouteType[] = [
  { path: '/control_panel/login', component: Login },
  {
    path: '/control_panel/:kind(monitoring|age_approval|keiji_approval|analysis/user|profile_image_approval/main|profile_image_approval/sub|profile_approval|company_partner_signup|edit_constants|menu_approval|agents/logo|change_user_type|transfer)',
    render: () => {
      return (
        <Index>
          {indexRoutes.map((route, key) => {
            return (
              <Route
                exact
                path={`/control_panel/${route.path}`}
                component={route.component}
                key={key}
              />
            );
          })}
        </Index>
      );
    },
  },
];

export default ServerControlPanel;
